export const icons = {
  power: 'power:svg:default:main|stroked',
  dashboard: 'dashboard:svg:default:main|stroked|other',
  settings: 'settings:svg:default:main|stroked|other',
  calendar: 'calendar:svg:default:other|stroked',
  compass: 'compass:svg:default:other|stroked',
  map: 'map:svg:default:other|stroked',
  money: 'money:svg:default:other|stroked',
  solar: 'solar:svg:default:other|stroked',
  moon: 'moon:svg:default:other|stroked',
  poop: 'poop:svg:default:other|stroked',
  knowledge: 'knowledge:svg:default:other|stroked',
  // access
  lock: 'lock:svg:default:main|stroked',
  unlock: 'unlock:svg:default:main|stroked',
  // states
  checked: 'checked:svg:default:main|stroked',
  // actions
  actions: 'actions:svg:default:main|filled',
  add: 'add:svg:default:main|stroked',
  edit: 'edit:svg:default:main|stroked',
  save: 'save:svg:default:main|stroked',
  delete: 'delete:svg:default:main|stroked',
  copy: 'copy:svg:default:main|stroked',
  cancel: 'cancel:svg:default:main|stroked',
  reload: 'reload:svg:default:main|stroked',
  cut: 'cut:svg:default:main|stroked',
  move: 'move:svg:default:main|stroked',
  close: 'close:svg:default:main|stroked',
  closeSmall: 'close-small:svg:default:main|stroked',
  expand: 'expand:svg:default:main|stroked',
  print: 'print:svg:default:main|stroked',
  filter: 'filter:svg:default:main|stroked',
  create: 'create:svg:default:main|stroked',
  smallUp: 'small-up:svg:default:main|stroked',
  smallDown: 'small-down:svg:default:main|stroked',
  send: 'send:svg:default:main|stroked',
  today: 'today:svg:default:main|filled',
  // navigation
  search: 'search:svg:default:main|stroked',
  menu: 'menu:svg:default:main|stroked',
  home: 'home:svg:default:main|stroked',
  more: 'more:svg:default:main|stroked',
  // information
  information: 'information:svg:default:main|stroked',
  question: 'question:svg:default:main|stroked',
  warning: 'warning:svg:default:main|stroked',
  stop: 'stop:svg:default:main|stroked',
  time: 'time:svg:default:main|stroked',
  help: 'help:svg:default:main|stroked',
  // media
  image: 'image:svg:default:other|stroked',
  camera: 'camera:svg:default:other|stroked',
  // rewind
  first: 'first:svg:default:other|stroked',
  last: 'last:svg:default:other|stroked',
  pause: 'pause:svg:default:other|stroked',
  play: 'play:svg:default:other|stroked',
  // internet
  signin: 'signin:svg:default:other|stroked',
  signout: 'signout:svg:default:other|stroked',
  link: 'link:svg:default:other|stroked',
  email: 'email:svg:default:other|stroked',
  anchor: 'anchor:svg:default:other|stroked',
  download: 'download:svg:default:other|stroked',
  cloud: 'cloud:svg:default:other|stroked',
  sync: 'sync:svg:default:other|stroked',
  sorting: 'sorting:svg:default:other|stroked',
  view: 'view:svg:default:other|stroked',
  viewHide: 'view-hide:svg:default:other|stroked',
  bubble: 'bubble:svg:default:other|stroked',
  selectClose: 'select-close:svg:default:other|stroked',
  selectOpen: 'select-open:svg:default:other|stroked',
  // programming
  code: 'code:svg:default:other|stroked',
  bug: 'bug:svg:default:other|stroked',
  // social
  like: 'like:svg:default:other|stroked',
  dislike: 'dislike:svg:default:other|stroked',
  profile: 'profile:svg:default:other|stroked',
  bell: 'bell:svg:default:other|stroked',
  team: 'team:svg:default:other|stroked',
  user: 'user:svg:default:other|stroked',
  messages: 'messages:svg:default:other|stroked',
  // chevron
  doubleChevronLeft: 'chevron-double-left:svg:default:controls|stroked',
  doubleChevronRight: 'chevron-double-right:svg:default:controls|stroked',
  chevronDown: 'chevron-down:svg:default:controls|stroked',
  chevronLeft: 'chevron-left:svg:default:controls|stroked',
  chevronRight: 'chevron-right:svg:default:controls|stroked',
  chevronUp: 'chevron-up:svg:default:controls|stroked',
  // arrow
  arrowUp: 'arrow-up:svg:default:controls|stroked',
  arrowDown: 'arrow-down:svg:default:controls|stroked',
  arrowLeft: 'arrow-left:svg:default:controls|stroked',
  arrowRight: 'arrow-right:svg:default:controls|stroked',
  // emoji
  evil: 'evil:svg:emoji:emoji|filled',
  laughter: 'laughter:svg:emoji:emoji|filled',
  sad: 'sad:svg:emoji:emoji|filled',
  shocked: 'shocked:svg:emoji:emoji|filled',
  skull: 'skull:svg:emoji:emoji|filled',
  smile: 'smile:svg:emoji:emoji|filled',
  wink: 'evil:svg:emoji:emoji|filled',
  neutral: 'neutral:svg:emoji:emoji|filled',
  // controls
  checkboxUnchecked: 'checkbox-unchecked:svg:default:controls|filled',
  checkboxChecked: 'checkbox-checked:svg:default:controls|filled',
  radioUnchecked: 'radio-unchecked:svg:default:controls|filled',
  radioChecked: 'radio-checked:svg:default:controls|filled',
  // countries
  abkhazia: 'abkhazia:svg:countries:flags',
  afghanistan: 'afghanistan:svg:countries:flags',
  alandIslands: 'aland-islands:svg:countries:flags',
  albania: 'albania:svg:countries:flags',
  algeria: 'algeria:svg:countries:flags',
  americanSamoa: 'american-samoa:svg:countries:flags',
  andorra: 'andorra:svg:countries:flags',
  angola: 'angola:svg:countries:flags',
  anguilla: 'anguilla:svg:countries:flags',
  antiguaAndBarbuda: 'antigua-and-barbuda:svg:countries:flags',
  argentina: 'argentina:svg:countries:flags',
  armenia: 'armenia:svg:countries:flags',
  aruba: 'aruba:svg:countries:flags',
  australia: 'australia:svg:countries:flags',
  austria: 'austria:svg:countries:flags',
  azerbaijan: 'azerbaijan:svg:countries:flags',
  azoresIslands: 'azores-islands:svg:countries:flags',
  bahamas: 'bahamas:svg:countries:flags',
  bahrain: 'bahrain:svg:countries:flags',
  balearicIslands: 'balearic-islands:svg:countries:flags',
  bangladesh: 'bangladesh:svg:countries:flags',
  barbados: 'barbados:svg:countries:flags',
  basqueCountry: 'basque-country:svg:countries:flags',
  belarus: 'belarus:svg:countries:flags',
  belgium: 'belgium:svg:countries:flags',
  belize: 'belize:svg:countries:flags',
  benin: 'benin:svg:countries:flags',
  bermuda: 'bermuda:svg:countries:flags',
  bhutan: 'bhutan:svg:countries:flags',
  bolivia: 'bolivia:svg:countries:flags',
  bonaire: 'bonaire:svg:countries:flags',
  bosniaAndHerzegovina: 'bosnia-and-herzegovina:svg:countries:flags',
  botswana: 'botswana:svg:countries:flags',
  brazil: 'brazil:svg:countries:flags',
  britishColumbia: 'british-columbia:svg:countries:flags',
  britishIndianOceanTerritory: 'british-indian-ocean-territory:svg:countries:flags',
  britishVirginIslands: 'british-virgin-islands:svg:countries:flags',
  brunei: 'brunei:svg:countries:flags',
  bulgaria: 'bulgaria:svg:countries:flags',
  burkinaFaso: 'burkina-faso:svg:countries:flags',
  burundi: 'burundi:svg:countries:flags',
  cambodia: 'cambodia:svg:countries:flags',
  cameroon: 'cameroon:svg:countries:flags',
  canada: 'canada:svg:countries:flags',
  canaryIslands: 'canary-islands:svg:countries:flags',
  capeVerde: 'cape-verde:svg:countries:flags',
  caymanIslands: 'cayman-islands:svg:countries:flags',
  centralAfricanRepublic: 'central-african-republic:svg:countries:flags',
  ceuta: 'ceuta:svg:countries:flags',
  chad: 'chad:svg:countries:flags',
  chile: 'chile:svg:countries:flags',
  china: 'china:svg:countries:flags',
  christmasIsland: 'christmas-island:svg:countries:flags',
  cocosIsland: 'cocos-island:svg:countries:flags',
  colombia: 'colombia:svg:countries:flags',
  comoros: 'comoros:svg:countries:flags',
  cookIslands: 'cook-islands:svg:countries:flags',
  corsica: 'corsica:svg:countries:flags',
  costaRica: 'costa-rica:svg:countries:flags',
  croatia: 'croatia:svg:countries:flags',
  cuba: 'cuba:svg:countries:flags',
  curacao: 'curacao:svg:countries:flags',
  cyprus: 'cyprus:svg:countries:flags',
  czechRepublic: 'czech-republic:svg:countries:flags',
  democraticRepublicOfCongo: 'democratic-republic-of-congo:svg:countries:flags',
  denmark: 'denmark:svg:countries:flags',
  djibouti: 'djibouti:svg:countries:flags',
  dominica: 'dominica:svg:countries:flags',
  dominicanRepublic: 'dominican-republic:svg:countries:flags',
  eastTimor: 'east-timor:svg:countries:flags',
  ecuador: 'ecuador:svg:countries:flags',
  egypt: 'egypt:svg:countries:flags',
  elSalvador: 'el-salvador:svg:countries:flags',
  england: 'england:svg:countries:flags',
  equatorialQuinea: 'equatorial-guinea:svg:countries:flags',
  eritrea: 'eritrea:svg:countries:flags',
  ersey: 'ersey:svg:countries:flags',
  estonia: 'estonia:svg:countries:flags',
  ethiopia: 'ethiopia:svg:countries:flags',
  europeanUnion: 'european-union:svg:countries:flags',
  falklandIslands: 'falkland-islands:svg:countries:flags',
  faroeIslands: 'faroe-islands:svg:countries:flags',
  fiji: 'fiji:svg:countries:flags',
  finland: 'finland:svg:countries:flags',
  france: 'france:svg:countries:flags',
  frenchPolynesia: 'french-polynesia:svg:countries:flags',
  gabon: 'gabon:svg:countries:flags',
  galapagosIslands: 'galapagos-islands:svg:countries:flags',
  gambia: 'gambia:svg:countries:flags',
  georgia: 'georgia:svg:countries:flags',
  germany: 'germany:svg:countries:flags',
  ghana: 'ghana:svg:countries:flags',
  gibraltar: 'gibraltar:svg:countries:flags',
  greece: 'greece:svg:countries:flags',
  greenland: 'greenland:svg:countries:flags',
  grenada: 'grenada:svg:countries:flags',
  guam: 'guam:svg:countries:flags',
  guatemala: 'guatemala:svg:countries:flags',
  guernsey: 'guernsey:svg:countries:flags',
  guinea: 'guinea:svg:countries:flags',
  guineaBissau: 'guinea-bissau:svg:countries:flags',
  haiti: 'haiti:svg:countries:flags',
  hawaii: 'hawaii:svg:countries:flags',
  honduras: 'honduras:svg:countries:flags',
  hongKong: 'hong-kong:svg:countries:flags',
  hungary: 'hungary:svg:countries:flags',
  iceland: 'iceland:svg:countries:flags',
  india: 'india:svg:countries:flags',
  indonesia: 'indonesia:svg:countries:flags',
  iran: 'iran:svg:countries:flags',
  iraq: 'iraq:svg:countries:flags',
  ireland: 'ireland:svg:countries:flags',
  isleOfMan: 'isle-of-man:svg:countries:flags',
  israel: 'israel:svg:countries:flags',
  italy: 'italy:svg:countries:flags',
  ivoryCoast: 'ivory-coast:svg:countries:flags',
  jamaica: 'jamaica:svg:countries:flags',
  japan: 'japan:svg:countries:flags',
  jordan: 'jordan:svg:countries:flags',
  kazakhstan: 'kazakhstan:svg:countries:flags',
  kenya: 'kenya:svg:countries:flags',
  kosovo: 'kosovo:svg:countries:flags',
  kuwait: 'kuwait:svg:countries:flags',
  kyrgyzstan: 'kyrgyzstan:svg:countries:flags',
  laos: 'laos:svg:countries:flags',
  latvia: 'latvia:svg:countries:flags',
  lebanon: 'lebanon:svg:countries:flags',
  lesotho: 'lesotho:svg:countries:flags',
  liberia: 'liberia:svg:countries:flags',
  libya: 'libya:svg:countries:flags',
  liechtenstein: 'liechtenstein:svg:countries:flags',
  lithuania: 'lithuania:svg:countries:flags',
  luxembourg: 'luxembourg:svg:countries:flags',
  macao: 'macao:svg:countries:flags',
  madagascar: 'madagascar:svg:countries:flags',
  madeira: 'madeira:svg:countries:flags',
  malawi: 'malawi:svg:countries:flags',
  malaysia: 'malaysia:svg:countries:flags',
  maldives: 'maldives:svg:countries:flags',
  mali: 'mali:svg:countries:flags',
  malta: 'malta:svg:countries:flags',
  marshallIsland: 'marshall-island:svg:countries:flags',
  martinique: 'martinique:svg:countries:flags',
  mauritania: 'mauritania:svg:countries:flags',
  mauritius: 'mauritius:svg:countries:flags',
  melilla: 'melilla:svg:countries:flags',
  mexico: 'mexico:svg:countries:flags',
  micronesia: 'micronesia:svg:countries:flags',
  moldova: 'moldova:svg:countries:flags',
  monaco: 'monaco:svg:countries:flags',
  mongolia: 'mongolia:svg:countries:flags',
  montenegro: 'montenegro:svg:countries:flags',
  montserrat: 'montserrat:svg:countries:flags',
  morocco: 'morocco:svg:countries:flags',
  mozambique: 'mozambique:svg:countries:flags',
  myanmar: 'myanmar:svg:countries:flags',
  namibia: 'namibia:svg:countries:flags',
  nauru: 'nauru:svg:countries:flags',
  nepal: 'nepal:svg:countries:flags',
  netherlands: 'netherlands:svg:countries:flags',
  newZealand: 'new-zealand:svg:countries:flags',
  nicaragua: 'nicaragua:svg:countries:flags',
  niger: 'niger:svg:countries:flags',
  nigeria: 'nigeria:svg:countries:flags',
  niue: 'niue:svg:countries:flags',
  norfolkIsland: 'norfolk-island:svg:countries:flags',
  northKorea: 'north-korea:svg:countries:flags',
  northenCyprus: 'northen-cyprus:svg:countries:flags',
  northernMarianasIslands: 'northern-marianas-islands:svg:countries:flags',
  norway: 'norway:svg:countries:flags',
  oman: 'oman:svg:countries:flags',
  orkneyIslands: 'orkney-islands:svg:countries:flags',
  ossetia: 'ossetia:svg:countries:flags',
  otan: 'otan:svg:countries:flags',
  pakistan: 'pakistan:svg:countries:flags',
  palau: 'palau:svg:countries:flags',
  palestine: 'palestine:svg:countries:flags',
  panama: 'panama:svg:countries:flags',
  papuaNewGuinea: 'papua-new-guinea:svg:countries:flags',
  paraguay: 'paraguay:svg:countries:flags',
  peru: 'peru:svg:countries:flags',
  philippines: 'philippines:svg:countries:flags',
  pitcairnIslands: 'pitcairn-islands:svg:countries:flags',
  poland: 'poland:svg:countries:flags',
  portugal: 'portugal:svg:countries:flags',
  puertoRico: 'puerto-rico:svg:countries:flags',
  qatar: 'qatar:svg:countries:flags',
  rapaNui: 'rapa-nui:svg:countries:flags',
  republicOfMacedonia: 'republic-of-macedonia:svg:countries:flags',
  republicOfTheCongo: 'republic-of-the-congo:svg:countries:flags',
  romania: 'romania:svg:countries:flags',
  russia: 'russia:svg:countries:flags',
  rwanda: 'rwanda:svg:countries:flags',
  sabaIsland: 'saba-island:svg:countries:flags',
  sahrawiArabDemocraticRepublic: 'sahrawi-arab-democratic-republic:svg:countries:flags',
  saintKittsAndNevis: 'saint-kitts-and-nevis:svg:countries:flags',
  samoa: 'samoa:svg:countries:flags',
  sanMarino: 'san-marino:svg:countries:flags',
  saoTomeAndPrincipe: 'sao-tome-and-principe:svg:countries:flags',
  sardinia: 'sardinia:svg:countries:flags',
  saudiArabia: 'saudi-arabia:svg:countries:flags',
  scotland: 'scotland:svg:countries:flags',
  senegal: 'senegal:svg:countries:flags',
  serbia: 'serbia:svg:countries:flags',
  seychelles: 'seychelles:svg:countries:flags',
  sicily: 'sicily:svg:countries:flags',
  sierraLeone: 'sierra-leone:svg:countries:flags',
  singapore: 'singapore:svg:countries:flags',
  sintEustatius: 'sint-eustatius:svg:countries:flags',
  sintMaarten: 'sint-maarten:svg:countries:flags',
  slovakia: 'slovakia:svg:countries:flags',
  slovenia: 'slovenia:svg:countries:flags',
  solomonIslands: 'solomon-islands:svg:countries:flags',
  somalia: 'somalia:svg:countries:flags',
  somaliland: 'somaliland:svg:countries:flags',
  southAfrica: 'south-africa:svg:countries:flags',
  southKorea: 'south-korea:svg:countries:flags',
  southSudan: 'south-sudan:svg:countries:flags',
  spain: 'spain:svg:countries:flags',
  sriLanka: 'sri-lanka:svg:countries:flags',
  stBarts: 'st-barts:svg:countries:flags',
  stLucia: 'st-lucia:svg:countries:flags',
  stVincentAndTheGrenadines: 'st-vincent-and-the-grenadines:svg:countries:flags',
  sudan: 'sudan:svg:countries:flags',
  suriname: 'suriname:svg:countries:flags',
  sweden: 'sweden:svg:countries:flags',
  switzerland: 'switzerland:svg:countries:flags',
  syria: 'syria:svg:countries:flags',
  taiwan: 'taiwan:svg:countries:flags',
  tajikistan: 'tajikistan:svg:countries:flags',
  tanzania: 'tanzania:svg:countries:flags',
  thailand: 'thailand:svg:countries:flags',
  tibet: 'tibet:svg:countries:flags',
  togo: 'togo:svg:countries:flags',
  tokelau: 'tokelau:svg:countries:flags',
  tonga: 'tonga:svg:countries:flags',
  transnistria: 'transnistria:svg:countries:flags',
  trinidadAndTobago: 'trinidad-and-tobago:svg:countries:flags',
  tubalu: 'tubalu:svg:countries:flags',
  tunisia: 'tunisia:svg:countries:flags',
  turkey: 'turkey:svg:countries:flags',
  turkmenistan: 'turkmenistan:svg:countries:flags',
  turksAndCaicos: 'turks-and-caicos:svg:countries:flags',
  ukraine: 'ukraine:svg:countries:flags',
  uganda: 'uganda:svg:countries:flags',
  unitedArabEmirates: 'united-arab-emirates:svg:countries:flags',
  unitedKingdom: 'united-kingdom:svg:countries:flags',
  unitedNations: 'united-nations:svg:countries:flags',
  unitedStatesOfAmerica: 'united-states-of-america:svg:countries:flags',
  uruguay: 'uruguay:svg:countries:flags',
  uzbekistn: 'uzbekistn:svg:countries:flags',
  vanuatu: 'vanuatu:svg:countries:flags',
  vaticanCity: 'vatican-city:svg:countries:flags',
  venezuela: 'venezuela:svg:countries:flags',
  vietnam: 'vietnam:svg:countries:flags',
  virginIslands: 'virgin-islands:svg:countries:flags',
  wales: 'wales:svg:countries:flags',
  yemen: 'yemen:svg:countries:flags',
  zambia: 'zambia:svg:countries:flags',
  zimbabwe: 'zimbabwe:svg:countries:flags',

  rocket: 'rocket:svg:default:stroked',
  // apps
  arnold: 'arnold:svg:apps:apps',
  angular: 'angular:svg:apps:apps',
  gitlab: 'gitlab:svg:apps:apps',
  dribbble: 'dribbble:svg:apps:apps',
  github: 'github:svg:apps:apps',
  figma: 'figma:svg:apps:apps',
  stackblitz: 'stackblitz:svg:apps:apps',
  animated: {
    runningMan: 'running-man:animated:default:animated',
    success: 'success:animated:default:animated',
    settings: 'settings:animated:default:animated|filled',
    bell: 'bell:animated:default:animated|filled',
    reload: 'reload:animated:default:animated|filled',
    spinner: 'spinner:animated:default:animated|stroked',
    // recording: 'recording:animated:default:animated',
    // warning: 'warning:animated:default:animated|colored',
    // bin: 'bin:animated:default:animated|colored',
    // arrowDown: 'arrow-down:animated:default:animated|colored',
    // arrowLeft: 'arrow-left:animated:default:animated|colored',
    // arrowRight: 'arrow-right:animated:default:animated|colored',
    // arrowUp: 'arrow-up:animated:default:animated|colored',
  }
};
